import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { LandingRouteService } from '@core/services/landing-route.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class LandingGuard implements CanActivate {
  constructor(
    private readonly landingRouteService: LandingRouteService,
    private readonly router: Router
  ) {}

  public canActivate(): Observable<UrlTree | false> {
    return this.landingRouteService.getLandingRoute$().pipe(map((route) => (route.length ? this.router.createUrlTree(route) : false)));
  }
}
